
import { RevCarousel } from '@ds/components/Carousel'
import { RevCarouselController } from '@ds/components/CarouselController'
import { RevIllustration } from '@ds/components/Illustration'
import { RevMediaViewer } from '@ds/components/MediaViewer'
import { openModal } from '@ds/components/ModalBase'
import { mapGetters } from 'vuex'

import { COUNTRIES, MODAL_NAMES } from '@config/constants'
import Precipitation from '@core/components/Precipitation/Precipitation'

import translations from './Gallery.translations'

export default {
  components: {
    RevCarousel,
    RevCarouselController,
    RevIllustration,
    RevMediaViewer,
    Precipitation,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
    mediaViewerName: () => MODAL_NAMES.PRODUCT.MEDIA_VIEWER,

    ...mapGetters({
      country: 'config/country',
    }),

    tracking() {
      return { name: 'product' }
    },

    controllerVariant() {
      return {
        desktop: 'thumbnails',
        mobile: 'dots',
      }
    },

    controllerPosition() {
      return {
        Lg: 'left',
        Sm: 'bottom',
      }
    },

    carouselImages() {
      // Temp. adding one out of four image for the US "Tech Reborn" campaign
      // Let's generate a number from 1 to 4 from the product uuid. We're not generating a random
      // number to avoid the difference between SSR and client side render.
      // How is it generated? We remove the - from the uuid, which is hexa. We parse it as a base16 number
      // and compute the modulo value
      const imageNumber =
        (parseInt(this.$route.params.uuid.replace('-', ''), 16) % 4) + 1
      const images =
        this.country === COUNTRIES.US
          ? [
              ...this.images,
              {
                url: this.$static(
                  `/img/product/tech-reborn/tech-reborn-img-${imageNumber}.jpg`,
                ),
                alt: '',
              },
            ]
          : this.images

      return images.map((image) => ({
        src: image.url,
        alt: image.alt,
      }))
    },
  },
  methods: {
    shouldLoadEagerly(index) {
      return index === 0 ? 'eager' : 'lazy'
    },
    handleCarouselClick() {
      this.openMediaViewer()
    },
    openMediaViewer() {
      openModal(this.mediaViewerName)
    },
  },
}
